import { Vue, i18n } from 'Common/vue';

import ShippingInfo from 'VueComponents/ShippingInfo.vue'

import "../layouts/default"

import 'Ui/slider';
import 'Ui/tabs';
import 'Ui/more-items';
import 'Ui/favorite-trigger';

import 'Components/seen-products';
import 'Components/modal/modal-remote';
import 'Components/modal/modal-watchdog';

import 'Common/lightgallery';

import { buildStars, initRatingForm, initUsefulRatingVote } from 'Functions/rating';
import { initAnchors, scrollToEl } from 'Functions/anchor';

initAnchors()
buildStars()
initRatingForm()
initUsefulRatingVote()

document.querySelectorAll('[data-has-component="shippingInfo"]').forEach(element => {
    new Vue({
        el: element,
        components: {
            ShippingInfo
        }
    })

    element.removeAttribute('data-has-component')
});

const productTabsEl = document.querySelector('#product-tabs');
if (productTabsEl) {
    productTabsEl.addEventListener('rTab.after.openTab', () => {
        const positionFromTop = productTabsEl.getBoundingClientRect().y
        const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0

        if (positionFromTop - headerHeight <= 0) {
            scrollToEl(productTabsEl, 0, 'instant')
        }
    })
}